export const updateObject = (oldObject, updatedProps) => {
    return {
        ...oldObject,
        ...updatedProps
    }
};

export const checkValidity = (value, rules) => {
    let isValid = true;
    if (!rules) {
        return true;
    }

    if (rules.required) {
        isValid = value.trim() !== '' && isValid;
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid
    }

    if (rules.maxLength) {
        isValid = value.length <= rules.maxLength && isValid
    }

    if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isPhone) {
        const pattern = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
        isValid = pattern.test(value) && isValid;
    }

    return isValid;
};

export const checkFormValidity = (form) => {
    let isValid = [true];
    for (let key in form) {
        if (form[key].validation.required) {
            isValid[0] = form[key].valid && isValid[0];
            if (!isValid[0]) {
                isValid.push(`Missing ${form[key].label}`)
            }
        }
    }
    return isValid;
}